import {CategoryModel} from '../../api/category-model';

export class CategoryViewModel {
  constructor(public category: CategoryModel) {
  }
}
